"use client";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
import { isServer } from "@travel/shared/utils";
export var usePortal = function (id, zIndex, fixed) {
    if (zIndex === void 0) { zIndex = 1000; }
    if (fixed === void 0) { fixed = false; }
    var _a = __read(useState(), 2), portal = _a[0], setPortal = _a[1];
    useEffect(function () {
        if (isServer)
            return;
        var el = document.getElementById(id);
        if (!el) {
            el = document.createElement("div");
            el.id = id;
            el.classList.add("travel__component");
            if (fixed) {
                Object.assign(el.style, {
                    position: "fixed",
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    zIndex: zIndex,
                });
            }
            document.body.appendChild(el);
        }
        setPortal(el);
    }, [id]);
    return portal;
};
